// extracted by mini-css-extract-plugin
export default {"video_player":"hPO6F","videoPlayer":"hPO6F","video_container":"dz3sm","videoContainer":"dz3sm"};